import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { callApi } from '../../utils/callApi';
import { ApiEvents } from '../../utils/SocketEvents';
import { GetTicket, TypeGetTicketR } from './actions';
import ActionTypes, { TTicket } from './types';

function* getTicketWorker(action: ReturnType<typeof GetTicket.request>): Generator {
  const { event_id, callBack } = action.payload as TypeGetTicketR;

  let success = true;
  try {
    const resp = (yield call(callApi, {
      method: 'post',
      data: {
        event_id,
      },
      path: ApiEvents.getTicket,
    })) as TTicket;
    yield put(GetTicket.success(resp));
  } catch (e) {
    success = false;
    yield put(GetTicket.error(e as string));
  } finally {
    if (callBack) yield call(callBack, success);
  }
}

function* watchRequest() {
  yield takeEvery(ActionTypes.GET_TICKET_R, getTicketWorker);
}

export default function* ticketSaga() {
  yield all([fork(watchRequest)]);
}
